<template>
  <v-menu
    ref="menu"
    v-model="open"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        :name="name"
        :label="schema.label"
        v-model="dateFormatted"
        :required="!schema.optional"
        :rules="dateRules"
        :error-messages="errorMessages"
        :solo="schema.solo"

        :prepend-icon="schema.icon"
        readonly
        v-on="on"
        clearable

        @input="handleInput"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="date"
      @input="handleInput"
      locale="es-cl"
      no-title
      scrollable
    >
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="open = false">Cerrar</v-btn>
    </v-date-picker>
  </v-menu>
</template>
<script>
import moment from '@/plugins/moment'
export default {
  props: {
    /** Current Value */
    value: { type: String },
    /** Validation Errors */
    errorMessages: { type: String },
    /** Field Name */
    name: { type: String, required: true },
    /** Field Schema */
    schema: { type: Object, default: () => ({}) },
    /** Disabled state */
    disabled: { type: Boolean, default: false }
  },
  components: {
  },
  data: vm => ({
    open: false,
    dateRules: [v => !!v || 'Campo Requerido.'],
    date: '',
    dateFormatted: vm.formatDate()
  }),
  /** Validation Rules */
  /* get validationRules () {
    const rules = []
    // Required validation
    if (!this.schema.optional) {
      rules.push((v) => v != null || 'Campo Requerido.')
    }
    return rules
  }, */
  watch: {
    date (val) {
      this.dateFormatted = this.formatDate(this.date)
    }
  },
  methods: {
    displayValue (value) {
      return value ? moment(value).format('DD-MM-YYYY') : ''
    },
    /* Formatea la fecha */
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    /** Input event handler */
    handleInput (value) {
      this.$emit('input', moment(value).utc().hour(12).toISOString())
      this.open = false
    }
  }
}
</script>
